export const SAVED_PROPERTIES_LIMIT = 6;
